import { apiRequest } from '@/services/apiService';
import { getDevModeState } from '@/services/cookieService';
import { eventBus } from '@/services/eventBus';

/**
 * @typedef {Object} KnowledgeCitation
 * @property {string} file_id
 * @property {string} filename
 * @property {number} score
 */

/**
 * @typedef {Object} KnowledgeHistoryEntry
 * @property {string} question
 * @property {string} answer
 */

/**
 * @typedef {Object} KnowledgeQueryResult
 * @property {string} answer
 * @property {boolean} canAnswer
 * @property {KnowledgeCitation[]} citations
 */

let subDataUrl = '/api/v1.1/data';

function resolveSubDataUrl() {
  const devModeState = getDevModeState();
  if (devModeState.isDevMode !== undefined) {
    subDataUrl = devModeState.isDevMode ? '/dev-api/api/v1.1/data' : '/api/v1.1/data';
  }
}

function handleEnvironmentChange(isDevMode) {
  subDataUrl = isDevMode ? '/dev-api/api/v1.1/data' : '/api/v1.1/data';
}

resolveSubDataUrl();
eventBus.on('environment-changed', handleEnvironmentChange);

/**
 * @param {string} question
 * @param {KnowledgeHistoryEntry[]} [history]
 * @returns {Promise<KnowledgeQueryResult>}
 */
export async function queryKnowledge(question, history) {
  const trimmed = question.trim();
  if (!trimmed) {
    throw new Error('Please enter a question.');
  }

  const payload = { question: trimmed };
  if (Array.isArray(history) && history.length > 0) {
    payload.history = history;
  }

  const url = `${subDataUrl}/knowledge/query/get`;
  const response = await apiRequest('post', url, payload);

  if (response.errorCode !== 0) {
    throw new Error(response.infoText || 'Unable to get an answer right now.');
  }

  const data = response.data || {};

  return {
    answer: data.answer || '',
    canAnswer: data.can_answer !== false,
    citations: Array.isArray(data.citations) ? data.citations : [],
  };
}

export function getSubDataUrl() {
  return subDataUrl;
}
